import { memo, useCallback } from "react";
import { Button } from "react-bootstrap";

const LOCATION_OPTIONS: { value: string; label: string }[] = [
  { value: "", label: "- Select -" },
  { value: "Breadford", label: "Breadford" },
  { value: "Brimingham", label: "Brimingham" },
  { value: "London", label: "Cardiff" },
  { value: "london", label: "London" },
  { value: "Manchester", label: "Manchester" },
  { value: "Leicester", label: "Leicester" },
  { value: "Scheffield", label: "Scheffield" },
  { value: "Glasgo", label: "Glasgo" },
];

function Form() {
  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
      // Form is uncontrolled, no state management needed
    },
    []
  );

  const handleSubmit = useCallback((e: React.FormEvent) => {
    e.preventDefault();
  }, []);

  return (
    <form
      className="container my-4"
      onSubmit={handleSubmit}
      aria-label="Event updates registration"
    >
      <div className="row g-3">
        <div className="col-md-6">
          <label className="form-label" htmlFor="event-form-firstName">
            First Name *
          </label>
          <input
            id="event-form-firstName"
            type="text"
            name="firstName"
            className="form-control"
            placeholder="First Name"
            required
            onChange={handleChange}
            autoComplete="given-name"
          />
        </div>

        <div className="col-md-6">
          <label className="form-label" htmlFor="event-form-lastName">
            Last Name *
          </label>
          <input
            id="event-form-lastName"
            type="text"
            name="lastName"
            className="form-control"
            placeholder="Last Name"
            required
            onChange={handleChange}
            autoComplete="family-name"
          />
        </div>

        <div className="col-md-6">
          <label className="form-label" htmlFor="event-form-company">
            Business/Company Name *
          </label>
          <input
            id="event-form-company"
            type="text"
            name="company"
            className="form-control"
            placeholder="Business/Company Name"
            required
            onChange={handleChange}
            autoComplete="organization"
          />
        </div>

        <div className="col-md-6">
          <label className="form-label" htmlFor="event-form-industry">
            Industry/Sector *
          </label>
          <input
            id="event-form-industry"
            type="text"
            name="industry"
            className="form-control"
            placeholder="Industry/Sector"
            required
            onChange={handleChange}
          />
        </div>

        <div className="col-md-6">
          <label className="form-label" htmlFor="event-form-email">
            Email *
          </label>
          <input
            id="event-form-email"
            type="email"
            name="email"
            className="form-control"
            placeholder="Email Address"
            required
            onChange={handleChange}
            autoComplete="email"
          />
        </div>

        <div className="col-md-6">
          <label className="form-label" htmlFor="event-form-phone">
            Phone/Mobile *
          </label>
          <input
            id="event-form-phone"
            type="tel"
            name="phone"
            className="form-control"
            placeholder="Mobile Number"
            required
            onChange={handleChange}
            autoComplete="tel"
          />
        </div>

        <div className="col-12">
          <label
            className="form-label"
            htmlFor="event-form-location"
          >
            Select Event Location You Are Interested In Attending *
          </label>
          <select
            id="event-form-location"
            name="location"
            className="form-select"
            required
            onChange={handleChange}
            aria-label="Event location"
          >
            {LOCATION_OPTIONS.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </div>

        <div className="col-12">
          <div className="form-check">
            <input
              className="form-check-input"
              type="checkbox"
              name="consent"
              id="consentCheck"
              onChange={handleChange}
            />
            <label className="form-check-label" htmlFor="consentCheck">
              I consent to have SMBF store my submitted information so they can
              respond to my events expression of interest to attend future
              events.
            </label>
          </div>
        </div>

        <div className="col-12">
          <Button className="px-4" type="submit">
            SUBMIT FORM
          </Button>
        </div>
      </div>
    </form>
  );
}

Form.displayName = "Form";

export default memo(Form);
